import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=24d25a4f&scoped=true&"
import script from "./Portfolio.vue?vue&type=script&lang=js&"
export * from "./Portfolio.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=24d25a4f&scoped=true&lang=css&"
import style1 from "./Portfolio.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Portfolio.vue?vue&type=style&index=2&id=24d25a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d25a4f",
  null
  
)

export default component.exports